<!--~
  ~ Copyright (c) 2010-2025 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<h2 mat-dialog-title></h2>
<mat-dialog-content>
    <p>
        The site requires your permission to access the device orientation
        sensors in order to display your direction on the map. Open permission request?
    </p>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button (click)="requestPermission()">Request Permission</button>
</mat-dialog-actions>
